import { Component, Input } from '@angular/core';
import { TuitionFeeSummaryDto } from '../../models/tuitionCalculation/tuitionFeeSummaryDto';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-tuitionfeesummary',
  standalone: true,
  imports: [TranslatePipe],
  templateUrl: './tuitionfeesummary.component.html',
  styleUrl: './tuitionfeesummary.component.css'
})
export class TuitionfeesummaryComponent {


  @Input() tuitionFeeSummary!: TuitionFeeSummaryDto;

  @Input() isGeneral: boolean = false;

  @Input() isStudent: boolean = false;

  @Input() isCompany: boolean = false;

  constructor() {

  }

  ngOnInit(): void {

    
  }
  

}
